const TokenUrlRegExp = /.*[#|%23]token\/(.+)/;
export const extractTokenFromUrl = url => {
    const matches = TokenUrlRegExp.exec(url);
    if (matches && matches.length > 1) {
        return matches[1];
    }
    return null;
};
//# sourceMappingURL=extractTokenFromUrl.js.map